import { ORGANIZATION_HIERARCHY, ROLES } from 'constants/enums'

export const tableHeaders = ({ organizationHierarchyId, showLastActivity, isLabelsEnabled, isAwardLabelsEnabled, isAssessorParticipants = false }) => [
  {
    id: 0,
    label: '',
    intlKey: '',
    sortableId: '',
    selector: true
  },
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id',
    sortableId: 'id'
  },
  {
    id: 2,
    label: 'First Name',
    intlKey: 'table.first_name',
    sortableId: 'firstName'
  },
  {
    id: 3,
    label: 'Last Name',
    intlKey: 'table.last_name',
    sortableId: 'lastName'
  },
  {
    id: 4,
    label: 'Email',
    intlKey: 'table.email',
    sortableId: 'email'
  },
  {
    id: 5,
    label: 'Levels',
    intlKey: 'table.levels',
    sortable: false
  },
  {
    id: 6,
    label: 'Last log added',
    intlKey: 'table.last_log_added',
    sortable: false,
    hide: !showLastActivity
  },
  {
    id: 7,
    label: 'Assessed Activities',
    intlKey: 'table.assessed_activities',
    hide: !isAssessorParticipants
  },
  {
    id: 8,
    label: 'Labels',
    intlKey: 'table.labels',
    sortable: false,
    /*sortableId: 'labels.label.name',*/
    hide: !isLabelsEnabled
  },
  {
    id: 9,
    label: 'Award Labels',
    intlKey: 'table.award_labels',
    sortable: false,
    /*sortableId: 'labels.label.name',*/
    hide: !isAwardLabelsEnabled
  },
  {
    id: 10,
    label: 'Award Leader',
    intlKey: 'table.award_leader',
    sortableId: 'awardLeaderLastName'
  },
  {
    id: 11,
    label: 'Award Unit',
    intlKey: 'table.award_unit',
    displayForRoles: [
      ROLES.NAO_STAFF.u,
      ROLES.IF_STAFF_SUPER.u,
      ROLES.IF_REGION.u,
      ROLES.IF_STAFF_USER.u,
      ROLES.IF_STAFF_VIEWER.u
    ]
  },
  {
    id: 12,
    label: 'NAO',
    intlKey:
      organizationHierarchyId === ORGANIZATION_HIERARCHY.IC.id
        ? 'table.ic'
        : 'table.country',
    displayForRoles: [
      ROLES.IF_STAFF_SUPER.u,
      ROLES.IF_REGION.u,
      ROLES.IF_STAFF_USER.u,
      ROLES.IF_STAFF_VIEWER.u
    ]
  },
  {
    id: 13,
    label: 'Status',
    intlKey: 'table.status',
    sortableId: 'personState'
  }
]
